module.exports = __webpack_public_path__ + "img/r4c1.060d1ff4.jpg";